import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_warranty_price_matrix_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  addon_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  from_price: fromDatatype.NumericDatatypeInterface;
  to_price: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_max_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  treatment_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_mst_warranty_price_matrix_RowClass implements bl_fi_mst_warranty_price_matrix_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  addon_fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  from_price: fromDatatype.NumericDatatypeInterface;
  to_price: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_max_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_incl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_unit_price_before_discount_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_unit_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_tax_amt: fromDatatype.NumericDatatypeInterface;
  treatment_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
